// extracted by mini-css-extract-plugin
module.exports = {"topnav":"TeamMiniNav_topnav__8K62z","toplink":"TeamMiniNav_toplink__NhgSD","active":"TeamMiniNav_active__lUe1n"};